// src/pages/ReservationTransferSuccess/ReservationTransferSuccess.jsx
import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ContentApp from '../ContentApp';
import EventHeader from '../Common/EventHeader/EventHeader';
import ShareReservation from '../ReservationCheck/ShareReservation/ShareReservation';
import ContentBottom from '../ContentBottom';
import Header from '../Common/Header/Header';
import { sendMessageToParent } from '../../helpers/iframe';

const ReservationTransferSuccess = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const app = useSelector((state) => state.app);

  const { paymentLink, paymentExpirationDate, showInfo } = location.state || {};

  return (
    <>
      <Header />
      <ContentApp classes='pb-0'>
        <EventHeader
          eventImg={showInfo.bannerImageUrl}
          eventName={showInfo?.name}
          eventDescription={showInfo.cityName}
          size='small'
        />

        <div className='mt-5 text-center'>
          <ShareReservation link={paymentLink} expirationDate={paymentExpirationDate} />

          <ContentBottom>
            <div className='mt-4 '>
              <button
                className='btn btn-primary w-100'
                onClick={() =>
                  app.isEmbedded
                    ? sendMessageToParent(window, { type: 'RESERVATION_SUCCESS' })
                    : history.push('/')
                }
              >
                {t('backToHome')}
              </button>
            </div>
          </ContentBottom>
        </div>
      </ContentApp>
    </>
  );
};

export default ReservationTransferSuccess;
